import { TurretActor } from "./TurretActor";
import { GameVars } from "../../../GameVars";
import * as Anuto from "../../../../engine/src";

export class TeleportTurretActor extends TurretActor {

    constructor(scene: Phaser.Scene, position: {r: number, c: number}, turret: Anuto.Turret) {

        super(scene, Anuto.GameConstants.TURRET_TELEPORT, position, turret, "texture_atlas_2", false);

        this.base.setFrame("torre_8_" + turret.level + "_01");
        this.base.setOrigin(.5, .75);
       
        this.base.anims.play("torre_8_" + turret.level);
    }

    public upgrade(): void {

        super.upgrade();

        this.base.setFrame("torre_8_" + this.anutoTurret.level + "_01");
        this.base.anims.play("torre_8_" + this.anutoTurret.level);
    }

    public shootGlue(): void {

        if (this.anutoTurret.shootAngle) {
            this.cannon.rotation = this.anutoTurret.shootAngle + Math.PI / 2;

            this.scene.tweens.add({
                targets: this.cannon,
                x: this.cannon.x - 5 * Math.sin(this.cannon.rotation),
                y: this.cannon.y + 5 * Math.cos(this.cannon.rotation),
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: GameVars.timeStepFactor === 1 ? 80 : 20,
                yoyo: true
            });
        }
    }
}
